import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch, apiPatch } from "@/lib/api";
import { notificationKeys } from "@/lib/query";

interface Notification {
  id: string;
  type: string | null;
  title: string | null;
  message: string | null;
  date: string | null;
  read: boolean;
  projectId: string | null;
}

export type { Notification };

export function useNotifications() {
  return useQuery({
    queryKey: notificationKeys.all,
    queryFn: () => apiFetch<Notification[]>("/notifications"),
  });
}

export function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiPatch<{ ok: boolean }>("/notifications/read-all", {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: notificationKeys.all }),
  });
}
